<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x" style="margin-bottom: 10px">
			<div class="search-item">
				<span class="label">服务项目名称</span>
				<el-input
					placeholder="请输入服务项目名称"
					class="input-box"
					clearable
					v-model.trim="searchBox.likeServiceName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">服务类别</span>
				<el-cascader
					placeholder="请选择服务类别"
					clearable
					v-model="searchBox.serviceType"
					:options="serviceTypeList"
					:props="{
						value: 'id',
						label: 'name',
						emitPath: false,
					}"
				></el-cascader>
			</div>
			<div class="search-item">
				<span class="label">状态</span>
				<el-select v-model="searchBox.serviceStatus" clearable>
					<el-option
						v-for="item in statusArr"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>

			<div class="search-item">
				<span class="label">归属部门</span>
				<el-select v-model="searchBox.branchId" clearable>
					<el-option
						v-for="item in branchIdList"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>
			<!--v-auth="'sw_operate_log_index'"-->
			<el-button
				v-auth="'sa_service_page'"
				type="primary"
				class="search-btn"
				@click="searchData"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_service_create'"
				type="warning"
				class="search-btn"
				@click="showVisible('add')"
				>新增</el-button
			>
			<el-button
				v-auth="'sa_service_import'"
				type="primary"
				class="search-l"
				@click="dialogVisibleImport = true"
				>批量导入服务</el-button
			>
			<el-button
				v-auth="'sa_service_hospital_rel'"
				type="primary"
				class="search-l"
				@click="addInstall"
				>批量设置服务网点</el-button
			>
			<el-button
				v-auth="'sa_service_hospital_rel'"
				type="primary"
				class="search-l"
				@click="toExport"
				>导出</el-button
			>
			<el-button class="search-btn fr" @click="goBack">返回</el-button>
		</div>

		<div class="table-x" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				border
				:height="tableHeight"
				class="mb20"
			>
				<el-table-column
					prop="id"
					align="center"
					label="服务ID"
					width="100"
				>
				</el-table-column>
				<el-table-column
					prop="serviceName"
					align="center"
					label="服务项目名称"
				>
				</el-table-column>
				<el-table-column
					prop="serviceType"
					align="center"
					label="服务类别"
				>
					<template slot-scope="scope">
						{{
							scope.row.serviceType
								| filterServiceType(serviceTypeList)
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="thirdCode"
					align="center"
					label="第三方编码"
				>
				</el-table-column>
				<el-table-column
					prop="createAdminName"
					align="center"
					label="创建人"
				>
				</el-table-column>
				<el-table-column
					prop="thirdCode"
					align="center"
					label="归属部门"
				>
					<template slot-scope="scope">
						{{ scope.row.branchId | filterValue(branchIdList) }}
					</template>
				</el-table-column>
				<el-table-column prop="price" align="center" label="单价">
					<template slot-scope="scope">
						{{ scope.row.price }}元/{{
							scope.row.pricingMethod == "PERSON" ? "人" : "次"
						}}
					</template>
				</el-table-column>
				<el-table-column label="状态" align="center" width="80px">
					<template slot-scope="scope">
						{{ scope.row.serviceStatus == "ON" ? "启用" : "停用" }}
					</template>
				</el-table-column>
				<el-table-column label="有效止期" align="center">
					<template slot-scope="scope">
						<span
							v-if="scope.row.isExpire == 2"
							class="error-tip"
							>{{ scope.row.expireTime }}</span
						>
						<span v-else>{{ scope.row.expireTime }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								v-auth="'sa_provider_view'"
								type="text"
								size="middle"
								class="table-btn"
								@click="showVisible('show', scope.row.id)"
								>查看</el-button
							>
							<el-button
								v-auth="'sa_provider_edit'"
								type="text"
								size="middle"
								class="table-btn"
								@click="showVisible('edit', scope.row.id)"
								>编辑</el-button
							>

							<el-button
								v-auth="'sa_service_status'"
								type="text"
								size="middle"
								class="table-btn"
								@click="
									changeStatus(
										scope.row,
										scope.row.serviceStatus
									)
								"
							>
								{{
									scope.row.serviceStatus != "ON"
										? "启用"
										: "停用"
								}}
							</el-button>

							<el-button
								v-auth="'sa_hospital'"
								type="text"
								size="middle"
								class="table-btn"
								@click="deletHandle(scope.row)"
								>删除</el-button
							>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页部分 -->
		<div class="pagination mb20">
			<el-pagination
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
				:current-page="searchBox.pageNo"
				:page-size="searchBox.pageSize"
				:page-sizes="[10, 50, 100]"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>

		<!-- 新增/查看/编辑 -->
		<el-dialog
			:title="titleText"
			:visible.sync="dialogVisibleAdd"
			center
			:close-on-click-modal="false"
			@close="toCloseDialog"
		>
			<el-form
				ref="formAdd"
				:model="formData"
				:rules="formRules"
				label-width="150px"
				style="padding-right: 50px"
			>
				<div class="title">基本信息</div>
				<el-form-item label="服务项目名称" prop="serviceName">
					<el-input
						:disabled="visibleType === 'show'"
						v-model.trim="formData.serviceName"
						clearable
						placeholder="请输入服务项目名称，限制50个字符"
						maxlength="50"
					></el-input>
				</el-form-item>

				<el-form-item label="服务类别" prop="serviceType">
					<el-cascader
						clearable
						:disabled="visibleType === 'show'"
						placeholder="请选择服务类别"
						v-model="formData.serviceType"
						:options="selectServiceTypeList"
						style="width: 100%"
						:props="{
							value: 'id',
							label: 'name',
							emitPath: false,
						}"
						@change="serviceTypeChange()"
					></el-cascader>
				</el-form-item>

				<el-form-item label="归属部门" prop="branchId">
					<el-select
						v-model="formData.branchId"
						clearable
						:disabled="visibleType === 'show'"
					>
						<el-option
							v-for="item in branchIdList"
							:value="item.value"
							:key="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="第三方产品编码" prop="thirdCode">
					<el-input
						:disabled="visibleType === 'show'"
						v-model.trim="formData.thirdCode"
						clearable
						placeholder="请输入第三方产品编码"
						maxlength="20"
					></el-input>
				</el-form-item>

				<el-form-item label="状态" prop="serviceStatus">
					<el-radio-group
						:disabled="visibleType === 'show'"
						v-model="formData.serviceStatus"
					>
						<el-radio label="ON">启用</el-radio>
						<el-radio label="OFF">停用</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- <el-form-item label="性别" prop="genderLimit">
                    <el-radio-group
                        :disabled="visibleType === 'show'"
                        v-model="formData.genderLimit"
                    >
                        <el-radio label="MALE">男</el-radio>
                        <el-radio label="FEMALE">女</el-radio>
                        <el-radio label="NONE">不限</el-radio>
                    </el-radio-group>
                </el-form-item> -->

				<el-form-item label="对接方式" prop="dockingMode">
					<el-radio-group
						:disabled="visibleType === 'show'"
						v-model="formData.dockingMode"
					>
						<el-radio label="ONLINE">线上</el-radio>
						<el-radio label="OFFLINE">线下</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="是否需要OCR解析" prop="ocrRequired">
					<el-radio-group
						:disabled="visibleType === 'show'"
						v-model="formData.ocrRequired"
					>
						<el-radio label="YES">是</el-radio>
						<el-radio label="NO">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="开通白名单" prop="whiteListRequired">
					<el-radio-group
						:disabled="visibleType === 'show'"
						v-model="formData.whiteListRequired"
					>
						<el-radio label="YES">是</el-radio>
						<el-radio label="NO">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="有效期" prop="validityCache">
					<el-date-picker
						:disabled="visibleType === 'show'"
						v-model="formData.validityCache"
						@change="toChangeTime"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="单价" prop="price">
					<el-col :span="10">
						<el-input-number
							style="width: 100%"
							:disabled="visibleType === 'show'"
							v-model.number="formData.price"
							:min="0"
							:controls="false"
							type="number"
							placeholder="请输入单价"
							:max="99999"
						>
						</el-input-number>
					</el-col>
					<el-col class="line" :span="2" style="text-align: center"
						>/</el-col
					>
					<el-col :span="5">
						<el-select
							:disabled="visibleType === 'show'"
							v-model="formData.pricingMethod"
							:placeholder="'请选择'"
						>
							<el-option label="次" value="TIME"></el-option>
							<el-option label="人" value="PERSON"></el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<!-- <el-form-item label="婚姻状态" prop="marryLimit">
                    <el-radio-group
                        :disabled="visibleType === 'show'"
                        v-model="formData.marryLimit"
                    >
                        <el-radio label="SINGLE">已婚</el-radio>
                        <el-radio label="MARRIED">未婚</el-radio>
                        <el-radio label="NONE">不限</el-radio>
                    </el-radio-group>
                </el-form-item> -->

				<!-- <el-form-item label="单价" prop="price">
                    <el-input
                        :disabled="visibleType === 'show'"
                        v-model.trim="formData.price"
                        clearable
                        type="number"
                        placeholder="请输入单价"
                        max="99999"
                    ></el-input>
                </el-form-item> -->

				<el-form-item
					:label="'服务网点(' + formData.hospitalIdList.length + ')'"
					prop="hospitalIdList"
				>
					<el-cascader
						clearable
						:disabled="visibleType === 'show'"
						v-model="formData.hospitalIdList"
						:options="locationList"
						placeholder="请选择服务网点"
						:props="defaultProps"
						:show-all-levels="false"
						style="width: 100%"
					/>
				</el-form-item>
				<div class="title">服务属性</div>
				<el-form-item label="性别" v-if="genderLimitVisible">
					<el-select
						:disabled="visibleType === 'show'"
						v-model="formData.genderLimit"
						:placeholder="'请选择性别'"
					>
						<el-option
							v-for="item in gerderList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="婚姻状况" v-if="marryLimitVisible">
					<el-select
						:disabled="visibleType === 'show'"
						v-model="formData.marryLimit"
						:placeholder="'请选择婚姻状况'"
					>
						<el-option
							v-for="item in marryList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button class="search-btn" @click="toCloseDialog"
					>取 消</el-button
				>
				<el-button
					v-if="visibleType !== 'show'"
					type="primary"
					class="search-btn"
					@click="addService"
					>确 定</el-button
				>
			</div>
		</el-dialog>

		<!-- 批量导入服务 -->
		<el-dialog
			title="批量导入服务"
			:visible.sync="dialogVisibleImport"
			center
			class="edit-dialog"
			:close-on-click-modal="false"
			@closed="toCloseDialogImport"
		>
			<el-form
				ref="templateForm"
				:model="templateForm"
				label-width="120px"
			>
				<el-form-item label="下载模板：">
					<!-- <el-button type="primary" class="search-btn" @click="downloadTemp">下载模版</el-button> -->
					<el-button type="primary" class="search-btn"
						><a
							class="no-a"
							:href="`${path}excel/供应商-服务项目导入模板.xlsx`"
							>下载模版</a
						>
					</el-button>
				</el-form-item>

				<el-form-item label="选择上传文档：">
					<el-upload
						class="upload-dom"
						ref="upload-dom"
						:action="uploadAction"
						:headers="uploadHeader"
						:limit="1"
						:auto-upload="false"
						:on-change="uploadChange"
						:before-remove="uploadBeforeRemove"
						:on-success="uploadSucess"
						:on-remove="uploadHandleRemove"
						:before-upload="uploadBefore"
						accept=".xlsx,.xls"
						style="width: 55%"
					>
						<el-button type="primary" icon="el-icon-upload"
							>上传附件</el-button
						>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="search-btn" @click="toCloseDialogImport"
					>取消</el-button
				>
				<el-button
					class="search-btn"
					type="primary"
					@click="sureSubmit('templateForm')"
					>确定</el-button
				>
			</div>
		</el-dialog>

		<!-- 批量设置服务网点 -->
		<el-dialog
			title="批量设置服务网点"
			:visible.sync="dialogVisibleInstall"
			center
			width="80%"
			:close-on-click-modal="false"
			@closed="toCloseDialogInstall"
		>
			<el-row>
				<el-col :span="12">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item label="服务列表：">
							<el-input
								v-model="servicesAvailable"
								placeholder="输入关键字进行过滤"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button
								type="primary"
								class="search-btn"
								@click="filtration('service')"
								>过滤</el-button
							>
						</el-form-item>
					</el-form>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeAll('service')"
						>全选</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeCancelAll('service')"
						>全部取消</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeReverse('service')"
						>反选</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeToggle('service')"
						>全部{{ serviceExpand ? "收起" : "展开" }}</el-button
					>
					<el-tree
						class="tree-wrapper"
						ref="serviceTree"
						:data="servicesAvailableLibrary"
						:expand-on-click-node="false"
						show-checkbox
						default-expand-all
						node-key="id"
						highlight-current
						:filter-node-method="filterNodeAvailable"
						:props="defaultPropsTree"
					>
					</el-tree>
				</el-col>
				<el-col :span="12">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item label="供应商网点：">
							<el-input
								v-model="supplierWebsite"
								placeholder="输入关键字进行过滤"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button
								type="primary"
								class="search-btn"
								@click="filtration('supplier')"
								>过滤</el-button
							>
						</el-form-item>
					</el-form>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeAll('supplier')"
						>全选</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeCancelAll('supplier')"
						>全部取消</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeReverse('supplier')"
						>反选</el-button
					>
					<el-button
						type="primary"
						class="search-btn"
						@click="treeToggle('supplier')"
						>全部{{ supplierExpand ? "收起" : "展开" }}</el-button
					>
					<el-tree
						class="tree-wrapper"
						ref="supplierTree"
						:data="supplierWebsiteLibrary"
						show-checkbox
						default-expand-all
						node-key="id"
						highlight-current
						@default-expand-all="supplierExpand"
						:filter-node-method="filterNodeWebsite"
						:props="defaultProps"
					>
					</el-tree>
				</el-col>
			</el-row>

			<div slot="footer" class="dialog-footer">
				<el-button class="search-btn" @click="toCloseDialogInstall"
					>取消</el-button
				>
				<el-button
					class="search-btn"
					type="primary"
					@click="serviceWebConfirm"
					>确定</el-button
				>
			</div>
		</el-dialog>
		<ImportFail
			:show="showImportFail"
			title="导入服务项目"
			:failObj="errorData"
			@receive="getReceive"
		/>
	</el-container>
</template>

<script>
	import { gerderList, marryList, branchIdList } from "@/assets/js/options";
	import { dateFormat } from "@/assets/js/until.js";
	import db from "@/assets/js/localstorage";
	import getService from "@/mixins/getService.mixin";
	import ImportFail from "./components/ImportFail";
	import { mapGetters } from "vuex";
	export default {
		name: "ServiceManager",
		components: {
			ImportFail,
		},
		data() {
			let checkPrice = (rule, value, cb) => {
				if (value && !this._valid.checkPrice(value)) {
					cb("小数点前限制7位，后限制2位");
				} else {
					cb();
				}
			};
			return {
				gerderList,
				marryList,
				genderLimitVisible: false, // 性别显示隐藏
				marryLimitVisible: false, // 性别显示隐藏
				validityCache: [],
				statusArr: [
					{ value: "ON", label: "启用" },
					{ value: "OFF", label: "停用" },
				],
				branchIdList,
				path: process.env.BASE_URL,
				providerId: "",
				searchBox: {
					likeServiceName: "",
					pageNo: 1,
					pageSize: 10,
				},
				tableHeight: 0,
				loading: false,
				tableData: [],
				total: 0,

				/**
				 * 新增/查看/编辑 -- 弹窗相关 **/
				dialogVisibleAdd: false, // 弹窗是否展示
				visibleId: -1, // 弹窗id （-1为新增）
				visibleType: "add", // 弹窗类型 add:新增  edit:编辑  show: 查看
				formData: {
					serviceName: "",
					serviceType: "",
					serviceStatus: "ON",
					dockingMode: "", // 对接方式
					thirdCode: "",
					hospitalIdList: [],
					effectiveTime: "", //生效日
					expireTime: "", //失效日
					ocrRequired: "NO", //是否需要ocr。0 否 1 是,可用值:NO,YES
					marryLimit: "NONE", //婚姻要求。0 不限 1 未婚 2 已婚,可用值:NONE,MARRIED,SINGLE
					genderLimit: "NONE", //性别要求。0 不限 1 男性 2 女性,可用值:NONE,MALE,FEMALE
					whiteListRequired: "NO", //是否需要开通白名单。0 否 1 是,可用值:NO,YES
					price: 0, //	单价
					pricingMethod: "TIME", //	计价方式。1次2人,可用值:TIME,PERSON
					validityCache: "",
				},
				formRules: {
					validityCache: [
						{
							required: true,
							message: "请选择有效期",
							trigger: "change",
						},
					],
					branchId: [
						{
							required: true,
							message: "请选择归属部门",
							trigger: "change",
						},
					],
					whiteListRequired: [
						{
							required: true,
							message: "请选择开通白名单",
							trigger: "change",
						},
					],
					ocrRequired: [
						{
							required: true,
							message: "请选择是否需要OCR解析",
							trigger: "change",
						},
					],
					serviceName: [
						{
							required: true,
							message: "请输入服务项目名称",
							trigger: "blur",
						},
					],
					thirdCode: [
						{
							required: true,
							message: "请输入第三方产品编码",
							trigger: "blur",
						},
					],
					serviceType: [
						{
							required: true,
							message: "请选择服务类别",
							trigger: "change",
						},
					],
					serviceStatus: [
						{
							required: true,
							message: "请选择状态",
							trigger: "change",
						},
					],
					genderLimit: [
						{
							required: true,
							message: "请选择婚姻状况",
							trigger: "change",
						},
					],
					marryLimit: [
						{
							required: true,
							message: "请选择性别",
							trigger: "change",
						},
					],
					dockingMode: [
						{
							required: true,
							message: "请选择对接方式",
							trigger: "change",
						},
					],
					price: [{ validator: checkPrice, trigger: "blur" }],
				},
				locationList: [], // 所在城市
				defaultProps: {
					children: "hospitalList",
					label: "hospName",
					value: "id",
					multiple: true,
				},

				/**
				 * 批量导入服务 -- 弹窗相关 **/
				uploadHeader: { token: db.get("ACCESS_TOKEN") }, //上传header
				uploadFile: null, //上传后文件
				uploadAction: "", //提交表单地址
				dialogVisibleImport: false, // 弹窗是否展示
				templateForm: {
					tempFile: "",
				},

				/**
				 * 批量设置服务网点 -- 弹窗相关 **/
				dialogVisibleInstall: false,
				defaultPropsTree: {
					children: "children",
					label: "serviceName",
				},
				supplierWebsite: "", // 供应商网点
				supplierExpand: true, // 是否展开所有节点
				supplierWebsiteLibrary: [],

				servicesAvailable: "", // 服务列表
				serviceExpand: true, // 是否展开所有节点
				servicesAvailableLibrary: [],
				showImportFail: false, //导入错误提示弹框
				errorData: {},
			};
		},
		mixins: [getService],
		filters: {
			filterServiceType(id, serviceTypeList) {
				if (!serviceTypeList?.length || !id) return "";
				let data;
				serviceTypeList.forEach((el) => {
					if (el.id == id) data = el;
					if (el?.children?.length) {
						el.children.forEach((e) => {
							if (e.id == id) data = e;
						});
					}
				});
				return data?.name;
			},
			filterValue(text, data) {
				return (
					data.find((item) => {
						if (text === item.value) {
							return item;
						}
					})?.label || text
				);
			},
		},
		created() {
			let name = this.$route.query.providerAbbr;
			this.$root.breadList = [
				{ name: "供应商", link: "" },
				{ name: "供应商管理", link: "" },
				{ name: `【${name}】服务项目管理`, link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				this.listenWindow();
				this.providerId = this.$route.query.id;
				this.getData();
				this.searchBox.serviceId = this.$route.query.tipid;
				this.serviceListData();
				this.getTree();
				this.uploadAction =
					this.getApiUrl("postServiceImport") +
					"?providerId=" +
					this.providerId;
			});
		},
		methods: {
			clrearTipid() {
				this.searchBox.serviceId = "";
			},
			/**
			 * 窗口改变重新获取高度
			 */
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight =
								this.$refs.tableBox.offsetHeight || 0;
						} catch (e) {}
					}, 300);
				});
			},
			getReceive(data) {
				this[data.key] = data.value;
			},
			/**
			 * 服务类型change
			 * @param {Boolean} isCreated 是否是在加载时执行该函数，如果是则不重置数据
			 */
			async serviceTypeChange(isCreated = false) {
				this.getServiceAttribute();
				if (!isCreated) {
					this.formData.genderLimit = "NONE";
					this.formData.marryLimit = "NONE";
				}
			},

			/**
			 * 是否显示服务属性
			 */
			getServiceAttribute() {
				var getServiceAttributeData = (list, id) => {
					let data = undefined;
					for (let i = 0; i < list.length; i++) {
						if (list[i].id === id) return list[i];
					}
					for (let i = 0; i < list.length; i++) {
						if (list[i]?.children?.length) {
							let d = getServiceAttributeData(list[i].children, id);
							d && (data = d);
						}
					}
					return data;
				};
				let l = this.serviceTypeList;
				let id = this.formData.serviceType;
				let data = getServiceAttributeData(l, id) || {};
				data.genderPropertyFlag === "YES"
					? (this.genderLimitVisible = true)
					: (this.genderLimitVisible = false);
				data.maritalPropertyFlag === "YES"
					? (this.marryLimitVisible = true)
					: (this.marryLimitVisible = false);
			},
			ocrChange() {},
			toChangeTime(val) {
				if (val && val.length) {
					this.formData.effectiveTime = dateFormat(val[0]);
					this.formData.expireTime = dateFormat(val[1]);
				} else {
					this.formData.effectiveTime = "";
					this.formData.expireTime = "";
				}
			},
			deletHandle(row) {
				this.$confirm("确认删除该服务?", "删除确认", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					beforeClose: async (action, instance, done) => {
						if (action === "confirm") {
							instance.confirmButtonLoading = true;
							instance.confirmButtonText = "执行中...";
							const res = await this.axios.post(
								this.getApiUrl("serviceDelete"),
								{ id: row.id },
								{
									toJSON: true,
								}
							);
							instance.confirmButtonLoading = false;
							if (res.code !== 1) {
								this.$message({
									type: "error",
									message: res.msg,
								});
							} else {
								this.$message({
									type: "success",
									message: "删除成功!",
								});
								setTimeout(() => {
									this.getData();
								}, 300);
							}
							done();
						} else {
							done();
						}
					},
				})
					.then(() => {})
					.catch((err) => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			goBack() {
				this.$router.go(-1);
			},
			addInstall() {
				this.dialogVisibleInstall = true;
				this.serviceListData();
				this.getTree();
			},
			searchData() {
				this.searchBox.pageNo = 1;
				this.getData();
				this.clrearTipid();
			},
			getData() {
				this.loading = true;
				let params = {
					...this.searchBox,
					providerId: this.providerId,
				};
				this.axios
					.get(this.getApiUrl("servicePage"), { params })
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							res.data.data.forEach((item) => {
								if (!item.expireTime) {
									item.isExpire = 1;
								} else if (
									new Date(item.expireTime).getTime() <
									new Date().getTime()
								) {
									item.isExpire = 3;
								} else if (
									new Date(item.expireTime).getTime() -
										new Date().getTime() <=
									30 * 24 * 60 * 60 * 1000
								) {
									item.isExpire = 2;
								} else {
									item.isExpire = 1;
								}
							});
							this.tableData = res.data.data || [];
							this.total = res.data.total;

							if (params.serviceId) {
								this.searchBox.likeServiceName =
									res.data.data[0].serviceName;
							}
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},

			// -- 翻页
			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},
			// -- 启用 && 停用
			async changeStatus(row, status) {
				let tips = `您是否确定${status == "ON" ? "停用" : "启用"}?`;
				if (status == "ON") {
					let res = await this.axios.get(
						this.getApiUrl("postProviderStatusCheck"),
						{
							params: {
								serviceId: row.id,
							},
						}
					);
					let data = res.data || {};
					if (data.isConnect && status == "ON")
						tips = "此服务当前有关联的服务项目，是否确定停用？";
				}
				this.$confirm(tips, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						let params = {
							id: row.id,
							status: status == "ON" ? "OFF" : "ON",
						};
						this.axios
							.post(this.getApiUrl("postServiceStatus"), params, {
								toJSON: true,
							})
							.then((res) => {
								if (res.code == 1) {
									this.$message({
										type: "success",
										message:
											status == "ON"
												? "停用"
												: "启用" + "成功",
									});
									this.getData();
								} else {
									this.$message.warning(res.msg);
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消操作",
						});
					});
			},

			/**
			 * 弹窗相关
			 **/
			/**
			 * 显示弹窗
			 * @param {string} type 弹窗类型 add:新增  edit:编辑  show: 查看
			 * @param {number|undefined} id 弹窗id
			 */
			showVisible(type = "add", id) {
				this.clearVisible();
				this.dialogVisibleAdd = true;
				this.visibleType = type;
				this.visibleId = id || -1;
				if (type !== "add") {
					this.getServiceDetail();
				}
			},
			// 清除弹窗数据
			clearVisible() {
				this.formData = {
					serviceName: "",
					serviceType: 0,
					serviceStatus: "ON",
					thirdCode: "",
					hospitalIdList: [],
					ocrRequired: "NO", //是否需要ocr。0 否 1 是,可用值:NO,YES
					marryLimit: "NONE", //婚姻要求。0 不限 1 未婚 2 已婚,可用值:NONE,MARRIED,SINGLE
					genderLimit: "NONE", //性别要求。0 不限 1 男性 2 女性,可用值:NONE,MALE,FEMALE
					whiteListRequired: "NO", //是否需要开通白名单。0 否 1 是,可用值:NO,YES
					price: 0, //	单价
					pricingMethod: "TIME", //	计价方式。1次2人,可用值:TIME,PERSON
					validityCache: "",
				};
			},
			/**
			 * 获取编辑/查看时的数据
			 */
			async getServiceDetail() {
				// 获取数据
				const res = await this.axios.get(this.getApiUrl("serviceView"), {
					params: {
						serviceId: this.visibleId,
					},
				});
				// 获取对应的服务网点
				const hospitalIdListRes = await this.axios.get(
					this.getApiUrl("serviceHospitalList"),
					{
						params: {
							providerId: this.providerId,
							serviceId: this.visibleId,
						},
					}
				);
				// 时间格式处理
				if (res?.data?.effectiveTime && res?.data?.expireTime) {
					res.data.validityCache = [
						new Date(res.data.effectiveTime.replaceAll("-", "/")),
						new Date(res.data.expireTime.replaceAll("-", "/")),
					];
					this.$nextTick(() => {
						// 等待this.formData赋值完成后执行
						this.toChangeTime(res.data.validityCache);
					});
				}
				// 服务网点处理
				let hospitalIdList = [];
				hospitalIdListRes.data.forEach((item) => {
					let data = this.getServiceDetailToHospitalIdList(item.id);
					if (data) hospitalIdList.push(data);
				});
				res.data.hospitalIdList = hospitalIdList;
				this.formData = res.data;
				this.serviceTypeChange(true);
			},
			/**
			 * getServiceDetail方法中获取服务网点的方法
			 * 去locationList中根据id查找，将数据转换成所需的格式
			 */
			getServiceDetailToHospitalIdList(id, returnArr, list, end) {
				if (!end) end = { end: false };
				if (!returnArr) returnArr = [];
				if (!list) list = this.locationList;
				if (list && list.length) {
					for (let i in list) {
						if (
							list[i].id &&
							list[i].id === id &&
							!list[i].hospitalList
						) {
							returnArr.push(id);
							end.end = true;
							return returnArr;
						} else {
							if (list[i].hospitalList) {
								let childrenId =
									typeof list[i].id === "number" ||
									typeof list[i].id === "string"
										? list[i].id
										: i;
								let childrenArr =
									this.getServiceDetailToHospitalIdList(
										id,
										[...returnArr, childrenId],
										list[i].hospitalList,
										end
									);
								if (childrenArr) return childrenArr;
							}
						}
					}
				}
			},
			// -- 获取服务类型列表
			serviceListData() {
				this.axios
					.get(this.getApiUrl("serviceList"), {
						params: {
							providerId: this.providerId,
						},
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.servicesAvailableLibrary = res.data || [];
						} else {
							this.$message.warning(res.msg);
						}
					});
			},
			// -- 获取服务网点(供应商网点)列表
			getTree() {
				this.axios
					.get(this.getApiUrl("hospitalTree"), {
						params: { providerId: this.providerId },
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							let data = this.formatTree(res.data);
							this.locationList = data || [];
							this.supplierWebsiteLibrary = data || [];
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			/**
			 * 处理服务网点三维列表位置
			 */
			formatTree(list) {
				return list.map((o, i) => {
					if (o.city || o.province) {
						o.hospName = o.city || o.province;
						delete o.city;
						delete o.province;
					}
					if (o.hospitalCityList) {
						o.hospitalList = o.hospitalCityList;
						delete o.hospitalCityList;
					}
					if (o.hospitalList && o.hospitalList.length)
						o.hospitalList = this.formatTree(o.hospitalList);
					if (!o.id && o.providerId) o.id = i;
					return o;
				});
			},
			// -- 新增确定
			addService() {
				this.$refs["formAdd"].validate((valid) => {
					if (!valid) {
						return false;
					}
					let hospitalIdList = [];
					if (this.formData.hospitalIdList) {
						this.formData.hospitalIdList.map((o) => {
							hospitalIdList.push(o[o.length - 1]);
						});
					}
					let params = {
						...this.formData,
						providerId: this.providerId,
						hospitalIdList,
					};
					if (
						Object.prototype.toString.call(params.serviceType) ===
						"[object Array]"
					) {
						params.serviceType =
							params.serviceType[params.serviceType.length - 1];
					}
					let api = {
						edit: "postServiceEdit",
						add: "postServiceCreate",
					}[this.visibleType];
					if (this.visibleType == "add") {
						this.clrearTipid();
					}
					if (!api) return;
					this.axios
						.post(this.getApiUrl(api), params, { toJSON: true })
						.then((res) => {
							this.submitLoading = false;
							if (res.code === 1) {
								this.getData();
								this.$message.success("操作成功");
								this.toCloseDialog();
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.submitLoading = false;
						});
				});
			},
			// 关闭弹窗，重置rule
			toCloseDialog() {
				this.$refs.formAdd.resetFields();
				this.dialogVisibleAdd = false;
			},

			/**
			 * 导入网点 **/
			//下载模板
			downloadTemp() {
				this.http
					.exportExcel(this._apiCore.sysNetworkExcelTemplate, null, "get")
					.then((res) => {
						if (res.code == 1) {
							const blob = new Blob([res.data]);
							var fileName = "服务模版" + ".xlsx";
							const elink = document.createElement("a");
							elink.download = fileName;
							elink.style.display = "none";
							elink.href = URL.createObjectURL(blob);
							document.body.appendChild(elink);
							elink.click();
							URL.revokeObjectURL(elink.href);
							document.body.removeChild(elink);
							this.$message({
								message: "下载成功",
								type: "success",
							});
						} else {
							this.$message.error("下载失败，请稍后再试");
						}
					});
			},
			// -- 文件上传确定按钮
			sureSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.uploadFile) {
							this.$message.warning("请选择文件");
							return;
						}
						//数据确认
						this.$refs["upload-dom"].submit();
					} else {
						return false;
					}
				});
			},
			//文件状态改变时
			uploadChange(file) {
				this.uploadFile = file;
			},
			//文件移除前
			uploadBeforeRemove(file) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			//文件上传前
			uploadBefore(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error("上传文件不能超过 10MB!");
				}
				return isLt10M;
			},
			//文件移除
			uploadHandleRemove() {
				this.uploadFile = null;
				this.$refs["upload-dom"].clearFiles();
			},
			//文件上传成功
			uploadSucess(res) {
				let { code, msg } = res;
				if (code == 1) {
					this.doErrorData(res.data);
				} else {
					this.$message.error(msg);
				}
				this.uploadHandleRemove();
			},
			doErrorData(res) {
				if (res.failList && res.failList.length == 0) {
					this.$message({
						type: "success",
						message: "导入成功",
					});
					this.dialogVisibleImport = false;
				} else {
					res.failList = res.failList.map((item) => {
						return Object.keys(item).map((el) => {
							return {
								value: el,
								label: item[el],
							};
						})[0];
					});
					res.fileName = "供应商服务项目导入失败信息表";
					res.headerData = 2; // 2为供应商服务项目表头信息
					this.errorData = res;
					this.showImportFail = true;
				}
				this.getData();
			},
			toCloseDialogImport() {
				this.uploadFile = null;
				this.dialogVisibleImport = false;
				this.$refs["upload-dom"].clearFiles();
				this.$refs["templateForm"].resetFields();
			},

			/**
			 * 批量设置服务网点 -- **/
			serviceWebConfirm() {
				let hospitalIdList = [],
					serviceIdList = [],
					a = this.$refs.supplierTree.getCheckedNodes(
						this.supplierWebsiteLibrary
					),
					b = this.$refs.serviceTree.getCheckedNodes(
						this.servicesAvailable
					);
				a.map((o) => hospitalIdList.push(o.id));
				b.map((o) => serviceIdList.push(o.id));

				// 报错校验
				let errText = "";
				serviceIdList.length === 0 && (errText = "请选择服务列表");
				hospitalIdList.length === 0 && (errText = "请选择供应商网点");
				if (errText) {
					this.$message({ type: "error", message: errText });
					return;
				}

				// 发起请求
				this.axios
					.post(
						this.getApiUrl("postServiceHospitalRel"),
						{
							hospitalIdList,
							serviceIdList,
							providerId: this.providerId,
						},
						{ toJSON: true }
					)
					.then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "操作成功" });
							this.getData();
							this.toCloseDialogInstall();
						} else {
							this.$message({ type: "warning", message: res.msg });
						}
					});
			},
			filterNodeWebsite(value, data) {
				if (!value) return true;
				return data.hospName.indexOf(value) !== -1;
			},
			filterNodeAvailable(value, data) {
				if (!value) return true;
				return data.serviceName.indexOf(value) !== -1;
			},
			filtration(key) {
				switch (key) {
					case "supplier":
						this.$refs.supplierTree.filter(this.supplierWebsite);
						break;

					case "service":
						this.$refs.serviceTree.filter(this.servicesAvailable);
						break;
				}
			},
			treeAll(key) {
				switch (key) {
					case "supplier":
						this.$refs.supplierTree.setCheckedNodes(
							this.supplierWebsiteLibrary
						);
						break;

					case "service":
						this.$refs.serviceTree.setCheckedNodes(
							this.servicesAvailableLibrary
						);
						break;
				}
			},
			treeCancelAll(key) {
				switch (key) {
					case "supplier":
						this.$refs.supplierTree.setCheckedKeys([]);
						break;

					case "service":
						this.$refs.serviceTree.setCheckedKeys([]);
						break;
				}
			},
			treeReverse(key) {
				switch (key) {
					case "supplier": {
						let res = this.$refs.supplierTree;
						let nodes = res.getCheckedNodes(true, true);
						this.batchSelect(
							this.supplierWebsiteLibrary,
							res,
							true,
							nodes
						);
						break;
					}

					case "service": {
						let res = this.$refs.serviceTree;
						let nodes = res.getCheckedNodes(true, true);
						this.batchSelect(
							this.servicesAvailableLibrary,
							res,
							true,
							nodes
						);
						break;
					}
				}
			},
			async toExport() {
				this.searchBox.providerId = this.$route.query.id;
				var params = { ...this.searchBox };
				Object.keys(params).forEach((key) => {
					if (
						Object.prototype.toString.call(params[key]) ===
						"[object Array]"
					) {
						params[key] =
							params[key].length == 1
								? params[key][0]
								: params[key].join(",");
					}
					if (
						params[key] === "" ||
						params[key] === undefined ||
						params[key] === null
					)
						delete params[key]; // 请求时删除冗余字段
				});
				delete params.pageNo;
				delete params.pageSize;
				let urlPath = this.getApiUrl("postServiceExport");
				this.$root.exportFile(urlPath, params, "服务项目导出");
			},
			// 全选处理方法
			batchSelect(nodes, refs, flag, seleteds) {
				if (typeof nodes != "undefined") {
					nodes.forEach((element) => {
						refs.setChecked(element, flag, true);
					});
				}

				if (typeof seleteds != "undefined") {
					seleteds.forEach((node) => {
						refs.setChecked(node, !flag, true);
					});
				}
			},
			treeToggle(key) {
				switch (key) {
					case "supplier":
						this.supplierExpand = !this.supplierExpand;
						this.$refs.supplierTree.$children.forEach(
							(item) => (item.expanded = this.supplierExpand)
						);
						break;

					case "service":
						this.serviceExpand = !this.serviceExpand;
						this.$refs.serviceTree.$children.forEach(
							(item) => (item.expanded = this.serviceExpand)
						);
						break;
				}
			},
			toCloseDialogInstall() {
				this.dialogVisibleInstall = false;
				this.$refs.supplierTree.setCheckedKeys([]);
				this.$refs.serviceTree.setCheckedKeys([]);
				this.supplierWebsite = "";
				this.servicesAvailable = "";
				this.filtration("supplier");
				this.filtration("service");
			},
		},
		computed: {
			titleText() {
				let str = "";
				switch (this.visibleType) {
					case "show":
						str = "查看服务";
						break;
					case "edit":
						str = "编辑服务";
						break;
					case "add":
						str = "新增服务";
						break;
				}
				return str;
			},
			...mapGetters(["userName"]),
		},
		beforeRouteLeave(to, from, next) {
			// this.$root.savePageCache(this.searchBox);
			if (to.name != "SupplierManager") {
				this.$root.removeCache("supplierQuery");
			} else {
				to.meta.keepAlive = true;
			}
			next(true);
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
	@import "@/assets/css/color.scss";
	.title {
		height: 30px;
		line-height: 30px;
		margin-bottom: 20px;
		font-weight: bold;
		padding-left: 20px;
		position: relative;
		&::before {
			content: "";
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			width: 8px;
			background-color: $theme;
		}
	}
	.search-l {
		margin-left: 10px;
		margin-right: 10px;
	}
	.tree-wrapper {
		margin-top: 30px;
	}
	.no-a {
		color: #fff;
		text-decoration: none;
	}
	.error-tip {
		color: #f56c6c;
	}
	::v-deep .el-input-number .el-input__inner {
		text-align: left;
	}
	::v-deep .el-form-item__label {
		white-space: pre-line;
	}
</style>
<style lang="scss">
	.el-message-box_style {
		.el-message-box__title {
			color: #f56c6c !important;
		}
	}
</style>